<body>
  <ul>
    <div>
      <input type="file" (change)="onFileSelected($event)">
      <button class="data-save-btn" (click)="salvarNoBanco(jsonData)">Data Save</button>

        <div *ngIf="showProgressBar">
          <progressbar [value]="progressValue" [max]="maxValue">{{ progressValue }} Saved lines</progressbar>
        </div>

      <a #downloadLink style="display: none;"></a>
      <div *ngIf="dataLoaded">
        <p>Total lines {{ jsonData.length }}</p>
        <table>
          <thead>
            <tr>
              <th>
                <button (click)="sortBy('Process')">Descrição</button>
              </th>
              <th>
                <button (click)="sortBy('Plate')">Placa</button>
              </th>
              <th>
                <button (click)="sortBy('Invoice')">Paradas</button>
              </th>
              <th>
                <button (click)="sortBy('Container')">Parada 1</button>
              </th>
              <th>
                <button (click)="sortBy('Step')">Parada 2</button>
              </th>
              <th>
                <button (click)="sortBy('Transport')">Parada 3</button>
              </th>
              <th>
                <button (click)="sortBy('Channel')">Parada 4</button>
              </th>
              <th>
                <button (click)="sortBy('ATA')">Destino 1</button>
              </th>
              <th>
                <button (click)="sortBy('Dias')">Destino 2</button>
              </th>
              <th>
                <button (click)="sortBy('FreeTime')">Destino 3</button>
              </th>
              <th>
                <button (click)="sortBy('TripCost')">Destino 4</button>
              </th>
              <th>
                <button (click)="sortBy('Handling')">Volumes</button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of jsonData; let i = index">
              <td>{{ item.description }}</td>
              <td>{{ item.Plate }}</td>
              <td>{{ item.Passos }}</td>
              <td >{{ item['Fornecedor 1'] != undefined ? item['Fornecedor 1'] + ' ' + (item['Janela 1']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' ' }}</td>
              <td >{{ item['Fornecedor 2'] != undefined ? item['Fornecedor 2'] + ' ' + (item['Janela 2']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' ' }}</td>
              <td >{{ item['Fornecedor 3'] != undefined ? item['Fornecedor 3'] + ' ' + (item['Janela 3']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' ' }}</td>
              <td >{{ item['Fornecedor 4'] != undefined ? item['Fornecedor 4'] + ' ' + (item['Janela 4']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' '}}</td>
              <td >{{ item['Destino 1'] != undefined ? item['Destino 1'] + ' ' + (item['JanelaDestino 1']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' '}}</td>
              <td >{{ item['Destino 2'] != undefined ? item['Destino 2'] + ' ' + (item['JanelaDestino 2']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' '}}</td>
              <td >{{ item['Destino 3'] != undefined ? item['Destino 3'] + ' ' + (item['JanelaDestino 3']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' '}}</td>
              <td >{{ item['Destino 4'] != undefined ? item['Destino 4'] + ' ' + (item['JanelaDestino 4']  | date : 'dd/MM/yyyy HH:mm': '+00:00') : ' '}}</td>        
              <td>{{ item.Volumes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ul>
</body>
<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>